/* ==========================================================================
   ÜRÜN KARTI RENK SWATCH SİSTEMİ (paylaşılan asset)
   Dosya: assets/pb-swatch.js

   product-block.liquid içindeki inline <script> bloklarıyla AYNI kod.
   Buraya taşınmasının sebebi: "Related products" gibi AJAX ile (innerHTML)
   yüklenen bölümlerde inline <script> etiketleri TARAYICI TARAFINDAN
   ÇALIŞTIRILMAZ. Bu dosya normal <script src="..."> olarak, AJAX ile
   değişmeyen bir yere eklendiği için her sayfa yüklemesinde güvenilir
   şekilde çalışır ve sayfadaki TÜM .pb-swatch / .pb-swatches elemanlarını
   (nasıl eklenmiş olursa olsun - normal render, AJAX, sayfalama) işler.
   ========================================================================== */

(function() {
  const updateSlider = (container, index) => {
    const targetIndex = String(index);
    container.querySelectorAll('.custom-slide').forEach(slide => {
      slide.classList.toggle('is-active', slide.getAttribute('data-index') === targetIndex);
      slide.classList.toggle('is-hidden', slide.getAttribute('data-index') !== targetIndex);
    });
    container.querySelectorAll('.js-nav-dot').forEach(dot => {
      dot.classList.toggle('active', dot.getAttribute('data-index') === targetIndex);
    });
  };

  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.js-nav-dot');
    if (dot) {
      e.preventDefault(); e.stopPropagation();
      updateSlider(dot.closest('.js-slider-parent'), dot.getAttribute('data-index'));
    }
  }, true);

  let sX = 0, sY = 0;
  document.addEventListener('touchstart', (e) => {
    const area = e.target.closest('.js-swipe-area');
    if (area) { sX = e.touches[0].clientX; sY = e.touches[0].clientY; }
  }, {passive: true});

  document.addEventListener('touchend', (e) => {
    const area = e.target.closest('.js-swipe-area');
    if (!area) return;
    const dX = sX - e.changedTouches[0].clientX;
    const dY = sY - e.changedTouches[0].clientY;
    if (Math.abs(dX) > Math.abs(dY) && Math.abs(dX) > 30) {
      const container = area.closest('.js-slider-parent');
      const dots = container.querySelectorAll('.js-nav-dot');
      const active = container.querySelector('.js-nav-dot.active');
      if(active) {
        const current = parseInt(active.getAttribute('data-index'));
        updateSlider(container, dX > 0 ? (current + 1) % dots.length : (current - 1 + dots.length) % dots.length);
      }
    }
  }, {passive: true});
})();

(function () {
  /* Türkçe renk adı → HEX (önceki projelerden taşınan sözlük) */
  var PB_COLOR_HEX = {
    "siyah": "#141414", "beyaz": "#FFFFFF", "gri": "#969696", "açık gri": "#D2D2D2",
    "koyu gri": "#505050", "gri beyaz": "#E6E1DC", "antrasit": "#373C41",
    "kırmızı": "#C81E1E", "bordo": "#821428", "koyu bordo": "#5A0A19", "kiremit": "#BE4B32",
    "turuncu": "#E66E1E", "oranj": "#EB8214", "sarı": "#F0D21E", "hardal": "#B9961E",
    "lacivert": "#19285A", "koyu lacivert": "#0F1941", "açık lacivert": "#3C5AA0",
    "indigo": "#4B0082", "mavi": "#1E64C8", "açık mavi": "#64A0E6", "koyu mavi": "#0F3C8C",
    "saks mavi": "#4682B4", "saks": "#4682B4", "buz mavi": "#AFD7EB", "petrol": "#1C5A64",
    "turkuaz": "#00B4BE", "mint": "#A5E1D2", "koyu mint": "#32A08C",
    "yeşil": "#328C46", "açık yeşil": "#82C878", "koyu yeşil": "#195A28", "haki": "#78825A",
    "pembe": "#F096AA", "açık pembe": "#FFC8D7", "pudra": "#F0C8C3", "somon": "#F0A082",
    "yavruağzı": "#D28278", "mor": "#823296", "lila": "#B482D2", "açık lila": "#DCC8F0",
    "mürdüm": "#6E2850", "mor siyah": "#3C1450",
    "bej": "#DCC8AA", "açık bej": "#F0E1C8", "koyu bej": "#B9A07D", "krem": "#FAF0D2",
    "ekru": "#F5EBD2", "camel": "#C3915A", "kahverengi": "#825028", "kahve": "#825028",
    "açık kahve": "#B48255", "koyu kahve": "#502D14", "kavun içi": "#F5AF50",
    "şampanya": "#F5E1BE", "altın": "#D2AF37", "gümüş": "#BEBEC8", "vizon": "#A08C78",
    "taba": "#8C6446", "ten": "#E6BE9B", "vişne": "#5A0A28", "şarabi": "#6E0F28",
    "safran": "#E6A31E",
    /* Kombine renkler */
    "beyaz siyah": "#C8C8C8", "siyah beyaz": "#323232", "beyaz lacivert": "#C8D2EB",
    "lacivert beyaz": "#19285A", "beyaz bordo": "#EBC8CD", "bordo beyaz": "#821428",
    "beyaz bej": "#F5EBDC", "beyaz gri": "#EBEBEB", "beyaz kahve": "#E6D2BE",
    "beyaz mavi": "#D2E1FA", "beyaz yeşil": "#D2F0D7", "beyaz lila": "#EBDCF5",
    "beyaz saks mavi": "#BED7EB", "beyaz turkuaz": "#BEF0F0",
    "beyaz açık lacivert": "#C3D2F0", "beyaz açık mavi": "#CDE1FA",
    "bordo lacivert": "#6E1428", "bordo siyah": "#5A0F1E", "lacivert bej": "#233769"
  };

  /* ── OTOMATİK EKLENEN RENKLER (Search & Discovery listesinden, önceden eksik olanlar) ──
     Yukarıdaki elle ayarlanmış renklere DOKUNULMADI, sadece sözlükte olmayanlar eklendi.
     Bu tonlar bir algoritma ile hesaplandı; beğenmediğin bir ton olursa manuel değiştir. */
  var PB_COLOR_HEX_AUTO = {
    "dark blue": "#1B2A6B", "dark grey": "#393E46", "denim": "#3B6FA0",
    "ekru-siyah": "#837D73", "füme": "#5C5C5C", "fuşya": "#D81B60",
    "fuşya etnik desen": "#D81B60", "fıstık yeşili": "#93C572", "gold": "#CFB53B",
    "gold fuşya": "#D3684D", "gold yeşil": "#7BB14D", "gold&silver": "#C7BF82",
    "grey": "#9EA7AA", "açelya dsn": "#E8A0BF", "açık kahverengi": "#C49A6C",
    "açık mavi - ekru": "#B5CCD0", "açık sarı": "#F5E176", "anrasit": "#393E46",
    "balıksırtı": "#9A9590", "bej-ekru": "#E0CCB1", "beyaz desenli": "#F5F5F0",
    "beyaz-taba": "#D6C5AD", "black": "#1A1A1A", "blue": "#2E86C1",
    "camel / lacivert": "#6E626B", "camel-ekru": "#D7BD9B", "gül kurusu": "#C17C8A",
    "indigo blue": "#3F51B5", "kahve kırçıllı": "#7B4B2A", "kemik": "#F5EDD6",
    "kiremit etnik": "#C0533A", "kum beji": "#D9C7A8", "kırçıllı": "#B5B0A8",
    "kırmızı desenli": "#C0392B", "kırmızı-mavi": "#775F76", "lacivert desenli": "#1B2A6B",
    "lacivert-ekru": "#84859B", "light blue": "#7EB8D4", "mavi desenli": "#2E86C1",
    "mavi etnik desen": "#2E86C1", "mavi lila": "#6485BA", "mavi-beyaz": "#91BDD8",
    "mavi-ekru": "#8DB3C6", "mavi-lacivert": "#245896", "mercan": "#FF7F50",
    "mercan beyaz": "#FABAA0", "mint yeşili": "#A8D8B9", "mor desen": "#8E44AD",
    "mor desenli": "#8E44AD", "nar-çiçeği": "#E8354A", "natural": "#E8DCC8",
    "natürel": "#E8DCC8", "okra": "#CC7722", "pembe desenli": "#F48FB1",
    "petrol etnik desen": "#005F73", "şarabi desenli": "#722F37", "sarafi desen": "#722F37",
    "sarı channel": "#F1C40F", "sarı desenli": "#F1C40F", "siyah - beyaz": "#878785",
    "siyah - camel": "#6D5A42", "siyah beyaz desenli": "#878785", "siyah desenli": "#1A1A1A",
    "siyah etnik": "#1A1A1A", "siyah etnik desen": "#1A1A1A", "siyah lale desen": "#1A1A1A",
    "tarçın": "#8B4513", "taş": "#A09080", "taş desen": "#A09080",
    "toprak": "#8B5A2B", "turuncu desenli": "#E67E22", "tüvit": "#A89A8C",
    "white": "#F5F5F0", "yağ yeşili": "#6E8B3D", "yeşil beyaz": "#8ED1A8",
    "yeşil channel": "#27AE60", "yeşil desen": "#27AE60", "yeşil desenli": "#27AE60"
  };
  for (var _k in PB_COLOR_HEX_AUTO) {
    if (!(_k in PB_COLOR_HEX)) PB_COLOR_HEX[_k] = PB_COLOR_HEX_AUTO[_k];
  }

  /* Türkçe karakterler için doğru küçük harfe çevirme (İ→i, I→ı bug'ını önler) */
  function pbNormalize(str) {
    return (str || '')
      .replace(/İ/g, 'i').replace(/I/g, 'ı')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function pbHexFor(colorName) {
    return PB_COLOR_HEX[pbNormalize(colorName)] || null;
  }

  /* ── Gerçek desen görselleri (leopar, ekose, kareli vb.) — flat hex'in yetersiz
     kaldığı isimler için. #cfs-image-map script tag'i 'color-filter-swatch-images'
     snippet'i ile bu sayfada zaten render ediliyor olmalı. */
  var PB_IMAGE_MAP = null;
  function pbLoadImageMap() {
    if (PB_IMAGE_MAP !== null) return PB_IMAGE_MAP;
    var el = document.getElementById('cfs-image-map');
    if (!el) { PB_IMAGE_MAP = {}; return PB_IMAGE_MAP; }
    try { PB_IMAGE_MAP = JSON.parse(el.textContent); }
    catch (e) { PB_IMAGE_MAP = {}; }
    return PB_IMAGE_MAP;
  }
  function pbImageFor(colorName) {
    var map = pbLoadImageMap();
    return map[pbNormalize(colorName)] || null;
  }

  function pbApplyHex(a) {
    var name = a.getAttribute('title');
    var hex = pbHexFor(name);
    if (hex) {
      /* Koleksiyon kartında sadece düz renk kullanılır */
      a.style.backgroundColor = hex;
      a.style.backgroundImage = 'none';
      return;
    }
    var patternUrl = pbImageFor(name);
    if (patternUrl) {
      /* Desenli/karışık renkler için gerçek doku görseli */
      a.style.backgroundImage = "url('" + patternUrl + "')";
      a.style.backgroundSize = 'cover';
      a.style.backgroundPosition = 'center';
      return;
    }
    /* Ne hex ne görsel varsa (tanınmayan/yeni bir renk), ürün fotoğrafına düş */
    var photo = a.getAttribute('data-photo');
    if (photo) a.style.backgroundImage = "url('" + photo + "')";
  }

  window.__pbApplyHex = pbApplyHex;

  /* Yeniden kullanılabilir tarama: sayfada o an bulunan tüm swatch noktalarına uygula.
     AJAX/infinite-scroll ile sonradan eklenen kartlar için dışarıdan da çağrılabilir. */
  function pbScanDots(root) {
    (root || document).querySelectorAll('.pb-swatch a[title]').forEach(pbApplyHex);
  }
  window.__pbScanDots = pbScanDots;

  /* Sayfa yüklendiğinde mevcut (liquid ile basılan) self swatch'lara uygula */
  pbScanDots();
})();

(function () {
  function pbInit(ul) {
    if (!ul || ul.dataset.loaded === 'true') return;
    ul.dataset.loaded = 'true';

    var title   = ul.dataset.title;
    var current = ul.dataset.handle;
    var kod     = ul.dataset.kod;
    if (!kod) return;

    function stripWidth(src) {
      var p = src.split('?');
      if (p.length < 2) return src;
      var qs = p[1].split('&').filter(function (s) { return s.split('=')[0] !== 'width'; }).join('&');
      return p[0] + (qs ? '?' + qs : '');
    }
    function sized(src, w) {
      var b = stripWidth(src);
      return b + (b.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function getImg(p) {
      var fi = p.featured_image;
      if (!fi && p.images && p.images.length) fi = p.images[0];
      if (!fi) return null;
      var src = typeof fi === 'string' ? fi : (fi.src || '');
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src || null;
    }
    function colorOf(p) {
      var c = '';
      (p.options || []).forEach(function (o) { if (o.name === 'Renk') c = o.values[0] || ''; });
      return c;
    }
    function kodOf(p) {
      var sku = (p.variants && p.variants[0] && p.variants[0].sku) || '';
      return sku.split('_')[0];
    }

    /* /search/suggest.json: tüm katalogda başlık eşleşmesi, koleksiyon sınırı yok */
    fetch('/search/suggest.json?q=' + encodeURIComponent(title) +
          '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data.resources.results.products || [])
          .filter(function (p) { return p.title === title && p.handle !== current; });
        if (!list.length) return;
        return Promise.all(list.map(function (p) {
          return fetch('/products/' + p.handle + '.js').then(function (r) { return r.json(); });
        }));
      })
      .then(function (products) {
        if (!products || !products.length) return;
        var matches = products.filter(function (p) { return kodOf(p) === kod; });
        if (!matches.length) return;
        matches.forEach(function (p) {
          var src   = getImg(p);
          var color = colorOf(p);
          var li = document.createElement('li');
          li.className = 'pb-swatch';
          var a = document.createElement('a');
          a.href  = '/products/' + p.handle;
          a.title = color;
          if (src) {
            a.setAttribute('data-photo', sized(src, 60));
            a.setAttribute('data-full', sized(src, 800));
          }
          if (window.__pbApplyHex) window.__pbApplyHex(a);
          var vh = document.createElement('span');
          vh.className = 'visually-hidden';
          vh.textContent = color;
          a.appendChild(vh);
          li.appendChild(a);
          ul.appendChild(li);
        });
      })
      .catch(function () {});
  }

  /* Sadece ekranda görünen kartlarda API çağrısı yap (performans).
     NOT: ul başlangıçta [hidden]/display:none DEĞİL — kendi rengini (self)
     her zaman gösteriyor. Bu sayede IntersectionObserver elementi düzgün
     takip edebiliyor ([hidden] elementler display:none olduğu için hiç
     kesişmiyor — önceki sürümdeki asıl hata buydu).
     Yeniden kullanılabilir tarama: AJAX/infinite-scroll ile sonradan eklenen
     kartlardaki .pb-swatches listeleri için de dışarıdan çağrılabilir. */
  function pbScanLists(root) {
    var lists = (root || document).querySelectorAll('.pb-swatches[data-loaded="false"]');
    var vh2 = window.innerHeight || document.documentElement.clientHeight;
    lists.forEach(function (ul) {
      var r = ul.getBoundingClientRect();
      if (r.top < vh2 + 200 && r.bottom > -200) {
        pbInit(ul);
        return;
      }
      if ('IntersectionObserver' in window) {
        if (!window.__pbSwatchObserver) {
          window.__pbSwatchObserver = new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                pbInit(entry.target);
                obs.unobserve(entry.target);
              }
            });
          }, { rootMargin: '200px' });
        }
        window.__pbSwatchObserver.observe(ul);
      } else {
        pbInit(ul);
      }
    });
  }
  window.__pbScanLists = pbScanLists;
  pbScanLists();

  /* Hover'da kart görselini o rengin fotoğrafıyla önizle; tıklama normal link olarak çalışır */
  if (!window.__pbSwatchHoverInit) {
    window.__pbSwatchHoverInit = true;

    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest('.pb-swatch a');
      if (!a) return;
      var ul = a.closest('.pb-swatches');
      var block = a.closest('product-block');
      if (!block || !ul) return;
      var img = block.querySelector('.custom-slide.is-active img');
      var full = a.getAttribute('data-full');
      if (img && full) {
        if (!img.dataset.origSrc) img.dataset.origSrc = img.src;
        img.src = full;
      }
      ul.querySelectorAll('.pb-swatch').forEach(function (li) { li.classList.remove('is-selected'); });
      a.parentElement.classList.add('is-selected');
    });

    document.addEventListener('mouseout', function (e) {
      var a = e.target.closest('.pb-swatch a');
      if (!a) return;
      var ul = a.closest('.pb-swatches');
      var block = a.closest('product-block');
      if (!block || !ul) return;
      if (ul.contains(e.relatedTarget)) return; /* aynı liste içinde geziniyorsa dokunma */
      var img = block.querySelector('.custom-slide.is-active img');
      if (img && img.dataset.origSrc) img.src = img.dataset.origSrc;
      var selfLi = ul.querySelector('.pb-swatch--self');
      ul.querySelectorAll('.pb-swatch').forEach(function (li) { li.classList.remove('is-selected'); });
      if (selfLi) selfLi.classList.add('is-selected');
    });
  }

  /* ── AJAX/infinite-scroll ile eklenen yeni kartları yakalama ──
     innerHTML ile eklenen <script> etiketleri tarayıcıda ÇALIŞMAZ — bu yüzden
     koleksiyon sayfası 2., 3. sayfaya AJAX ile geçtiğinde yukarıdaki taramalar
     kendiliğinden tekrar tetiklenmez ve yeni kartlardaki swatch'lar boş kalır.
     Bu gözlemci, DOM'a herhangi bir yeni ürün kartı eklendiğinde (sayfa
     numarası ne olursa olsun) iki taramayı da otomatik tekrar çalıştırır. */
  if (!window.__pbMutationObserverInit) {
    window.__pbMutationObserverInit = true;
    var pbRescanPending = false;
    var pbObserver = new MutationObserver(function () {
      if (pbRescanPending) return;
      pbRescanPending = true;
      requestAnimationFrame(function () {
        pbRescanPending = false;
        if (window.__pbScanDots) window.__pbScanDots();
        if (window.__pbScanLists) window.__pbScanLists();
      });
    });
    pbObserver.observe(document.body, { childList: true, subtree: true });
  }
})();